import { Info, Visibility } from '@mui/icons-material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { DocumentIndicatorDocumentDetails } from 'pages/Finance/Components/Collection/components/Documents/components/DocumentsIndicators/components/FilteredDocuments';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showBusinessNetwork } from 'services/redux/businessNetworkSlice';

import { deleteCollectionManagementById } from '../../../../../../../../../../lib/api';
import {
  getDocumentsForCollection,
  getManagementsByBusiness,
} from '../../../../../../../../../../lib/api/collections';
import { downloadFilesFromRequest } from '../../../../../../../../../../lib/api/files';
import DocumentsPreviewer, {
  useDocumentPreview,
} from '../../../../../../../../../../lib/common/DocumentsPreviewer';
import CustomButton from '../../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../../lib/designSystem/CircularProgress';
import ConfirmAndExecuteDialog from '../../../../../../../../../../lib/designSystem/ConfrimAndExecuteDialog';
import HeaderWithActions from '../../../../../../../../../../lib/designSystem/HeaderWithActions';
import RequirementsDialog from '../../../../../../../../../../lib/designSystem/RequirementsDialog';
import EnhancedTable from '../../../../../../../../../../lib/designSystem/Table';
import {
  getShortString,
  loggerDev,
  showAlert,
} from '../../../../../../../../../../lib/functions/utils';
import EditManagement from '../../../Created/components/EditManagement';
import RescheduleManagement from '../../../Created/components/ReSchedule';
import MultiComplete from './components/MultiComplete';
import MultiDelete from './components/MultiDelete';
import MultiReschedule from './components/MultiReschedule';
interface ManagementsDetailsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  business: {
    identifier: string;
    name: string;
  };
  byStakeholder: boolean;
  handleOpenCreateNewManagementFromCompletion: (documentId: string) => void;
  handleOpenCreateNewMultiManagementFromCompletion: (
    documentIds: string[],
  ) => void;
  reloadPage: () => void;
}

const ManagementsDetails = (props: ManagementsDetailsProps) => {
  const {
    open,
    setOpen,
    business,
    byStakeholder,
    handleOpenCreateNewManagementFromCompletion,
    handleOpenCreateNewMultiManagementFromCompletion,
    reloadPage,
  } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [managements, setManagements] = useState<any[]>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [totalWithNoManagements, setTotalWithNoManagements] = useState(0);
  const [openFilteredDocuments, setOpenFilteredDocuments] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [openEditManagement, setOpenEditManagement] = useState(false);
  const [description, setDescription] = useState('');
  const [possiblePaymentDate, setPossiblePaymentDate] = useState('');

  const [rescheduleManagementOpen, setRescheduleManagementOpen] =
    useState(false);
  const [openEditManagementId, setOpenEditManagementId] = useState(0);
  const [dueDate, setDueDate] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogTitle, setConfirmDialogTitle] = useState('');
  const [confirmDialogDescription, setConfirmDialogDescription] = useState('');
  const [confirmAction, setConfirmAction] = useState<() => Promise<void>>(
    () => Promise.resolve,
  );
  const [buttonColor, setButtonColor] = useState<
    'primary' | 'error' | 'warning'
  >('primary');

  const [selectedManagements, setSelectedManagements] = useState<number[]>([]);

  const [openMultiComplete, setOpenMultiComplete] = useState(false);
  const [managementsToComplete, setManagementsToComplete] = useState<any[]>([]);

  const [openMultiDelete, setOpenMultiDelete] = useState(false);
  const [managementsToDelete, setManagementsToDelete] = useState<any[]>([]);

  const [openMultiReschedule, setOpenMultiReschedule] = useState(false);
  const [managementsToReschedule, setManagementsToReschedule] = useState<any[]>(
    [],
  );

  const [currentDocumentKey, setCurrentDocumentKey] = useState<string>('');
  const [pendingFileName, setPendingFileName] = useState<string>('');

  const [openRequirementsDialog, setOpenRequirementsDialog] = useState(false);
  const [documentId, setDocumentId] = useState<string>('');
  const [documentAlias, setDocumentAlias] = useState<string>('');

  const {
    previewOpen,
    previewLoading,
    previewError,
    currentPreviewFile,
    blobUrl,
    contentType,
    handlePreview,
    handleClosePreview,
    setPreviewError,
    canPreviewFileName,
  } = useDocumentPreview({
    requestId: currentDocumentKey,
    requestType: 'document',
  });

  useEffect(() => {
    if (currentDocumentKey && pendingFileName) {
      handlePreview(pendingFileName);
      setPendingFileName('');
    }
  }, [currentDocumentKey, pendingFileName, handlePreview]);

  useEffect(() => {
    if (previewError && currentDocumentKey) {
      console.error('Preview error detected:', previewError);
      handleClosePreview();
      showAlert(
        dispatch,
        'error',
        'No hay archivo PDF disponible para este documento',
      );
    }
  }, [previewError, currentDocumentKey, dispatch, handleClosePreview]);

  const setUp = async () => {
    setLoading(true);
    try {
      const response = await getManagementsByBusiness(
        dispatch,
        business.identifier,
      );
      let query = 'managements=free&';
      if (byStakeholder) {
        query += `stakeholderIdentifier=${business.identifier}`;
      } else {
        query += `businessIdentifier=${business.identifier}`;
      }
      setManagements(response || []);

      const documents = await getDocumentsForCollection(dispatch, query);
      setDocuments(documents.data);
      setTotalWithNoManagements(documents.totalWithNoManagements);
      setPagination(documents.pagination);
    } catch (error) {
      loggerDev(error);
    }
    setLoading(false);
  };

  const handleDelete = async (id: number) => {
    if (!id) return;

    setLoading(true);
    try {
      await deleteCollectionManagementById(dispatch, id);
      showAlert(dispatch, 'success', 'Gestión eliminada');
      window.location.reload();
    } catch (error) {
      loggerDev(error);
      showAlert(dispatch, 'error', 'Error al eliminar la gestión');
    }
    setLoading(false);
  };

  const handleConfirmDeleteDialog = (id: number) => {
    setConfirmDialogTitle('Eliminar gestión ' + `#${id}`);
    setConfirmDialogDescription(
      '¿Estás seguro de que deseas eliminar la gestión?',
    );
    setConfirmAction(() => async () => await handleDelete(id)); // Corregido
    setButtonColor('error');
    setConfirmDialogOpen(true);
  };

  const handleComplete = async (id: number) => {
    const management: any = managements.find(
      (management: any) => management.id === id,
    );
    setOpenEditManagement(true);
    setOpenEditManagementId(id);
    setDescription(management.description);
    if (management.possiblePaymentDate) {
      const possiblePaymentDate = new Date(management.possiblePaymentDate);
      setPossiblePaymentDate(dayjs(possiblePaymentDate).format('YYYY-MM-DD'));
    } else {
      setPossiblePaymentDate('');
    }
  };

  const handleReschedule = (id: number) => {
    setRescheduleManagementOpen(true);
    const management: any = managements.find(
      (management: any) => management.id === id,
    );
    if (!management) return;
    const dueDate = new Date(management.dueDate);
    setOpenEditManagementId(id);
    if (dueDate) {
      dueDate.setUTCHours(11, 59, 59, 999);
      setDueDate(dayjs(dueDate).format('YYYY-MM-DD'));
    } else {
      setDueDate('');
    }
  };

  const handleMultiComplete = () => {
    const managementsFound = managements.filter((management: any) =>
      selectedManagements.includes(management.id),
    );
    setManagementsToComplete(managementsFound);
    setOpenMultiComplete(true);
  };

  const handleMultiDelete = () => {
    const managementsFound = managements.filter((management: any) =>
      selectedManagements.includes(management.id),
    );
    setManagementsToDelete(managementsFound);
    setOpenMultiDelete(true);
  };

  const handleMultiReschedule = () => {
    const managementsFound = managements.filter((management: any) =>
      selectedManagements.includes(management.id),
    );
    setManagementsToReschedule(managementsFound);
    setOpenMultiReschedule(true);
  };

  const actions = [
    {
      action: handleConfirmDeleteDialog,
      actionLabel: 'Eliminar',
    },
    {
      action: handleComplete,
      actionLabel: 'Completar',
    },
    {
      action: handleReschedule,
      actionLabel: 'Reprogramar',
    },
  ];

  const handleShowBusinessDetails = () => {
    dispatch(
      showBusinessNetwork({
        id: business.identifier,
        name: business.name,
      }),
    );
  };

  const handlePreviewDocumentPDF = async (managementId: number) => {
    const management = managements.find(
      (management: any) => management.id === managementId,
    );
    if (!management) return;

    const documentKey = `${management.businessIdentifier}-${management.folio}`;
    const fileName = `${documentKey}.pdf`;

    if (!canPreviewFileName(fileName)) {
      showAlert(
        dispatch,
        'error',
        'Este tipo de archivo no se puede previsualizar',
      );
      return;
    }

    // Set the document key as the requestId for the hook
    setCurrentDocumentKey(documentKey);
    // Set the pending filename to be handled by the useEffect
    setPendingFileName(fileName);
  };

  const handleDownloadDocumentPDF = async (managementId: number) => {
    const management = managements.find(
      (management: any) => management.id === managementId,
    );
    if (!management) return;

    const documentKey = `${management.businessIdentifier}-${management.folio}`;
    setLoading(true);
    try {
      const data = {
        requestId: documentKey,
        fileName: `${documentKey}.pdf`,
        requestType: 'document',
      };
      const response = await downloadFilesFromRequest(dispatch, data);
      if (response) {
        window.open(response);
      } else {
        showAlert(dispatch, 'error', 'No hay archivo para descargar');
      }
    } catch (error) {
      console.error(error);
      showAlert(dispatch, 'error', 'Error al descargar el documento');
    }
    setLoading(false);
  };

  const handleOpenRequirementsDialog = (rowId: string) => {
    const management = managements.find(
      (x: (typeof managements)[0]) => x.id === rowId,
    );
    if (management) {
      setDocumentId(management.documentId);
      setDocumentAlias(`Folio ${management.folio}`);
      setOpenRequirementsDialog(true);
    }
  };

  const handlePreviewDocumentPDFObject = {
    key: 'previewDocumentPDF',
    label: '',
    handleAction: handlePreviewDocumentPDF,
    icon: <Visibility />,
  };

  const handleRequirements = {
    key: 'requirements',
    label: '',
    handleAction: handleOpenRequirementsDialog,
    type: 'requirements',
  };

  useEffect(() => {
    void setUp();
  }, []);

  return (
    <div>
      <Dialog open={open} maxWidth="xl">
        <DialogTitle>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6">
              {byStakeholder
                ? `Gestiones del deudor ${getShortString(business.name)} (${business.identifier})`
                : `Gestiones del cliente ${getShortString(business.name)} (${business.identifier})`}
            </Typography>
            <IconButton onClick={handleShowBusinessDetails}>
              <Info />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div style={{ minHeight: '200px' }}>
              <CenteredCircularProgress type="dialog" />
            </div>
          ) : (
            <div>
              <HeaderWithActions
                customTitle={
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 10 }}
                  >
                    <Typography
                      onClick={() => {
                        setOpenFilteredDocuments(true);
                      }}
                      style={{
                        cursor:
                          totalWithNoManagements > 0 ? 'pointer' : 'default',
                      }}
                      color={
                        totalWithNoManagements > 0
                          ? '#ffa500'
                          : 'text.secondary'
                      }
                      fontWeight={600}
                    >
                      {totalWithNoManagements > 0
                        ? `Esta empresa tiene ${totalWithNoManagements} documentos sin gestión programada`
                        : 'Todos los documentos de esta empresa tienen una gestión programada'}
                    </Typography>
                  </div>
                }
                variant={'body1'}
                buttons={[
                  {
                    name: 'Eliminar',
                    color: 'error',
                    disabled: selectedManagements.length === 0,
                    action: handleMultiDelete,
                  },
                  {
                    name: 'Reprogramar',
                    color: 'warning',
                    disabled: selectedManagements.length === 0,
                    action: handleMultiReschedule,
                  },
                  {
                    name: 'Completar',
                    color: 'success',
                    disabled: selectedManagements.length === 0,
                    action: handleMultiComplete,
                  },
                ]}
              />
              <EnhancedTable
                dataHeaders={[
                  // handlePreviewDocumentPDFObject,
                  handleRequirements,
                  { key: 'id', label: 'ID', type: 'numeric-id' },
                  {
                    key: 'elementType',
                    label: 'Tipo',
                    type: 'collection-type',
                  },
                  { key: 'description', label: 'Descripción' },
                  { key: 'folio', label: 'Documento' },
                  {
                    key: 'businessName',
                    label: 'Cliente',
                  },
                  {
                    key: 'businessIdentifier',
                    label: 'Rut cliente',
                  },
                  {
                    key: 'stakeholderName',
                    label: 'Deudor',
                  },
                  {
                    key: 'stakeholderIdentifier',
                    label: 'Rut deudor',
                  },
                  { key: 'dueDate', label: 'Fecha gestión', type: 'due-date' },
                  {
                    key: 'issuedDate',
                    label: 'Fecha emisión',
                    type: 'eight-days-date',
                  },
                  {
                    key: 'originalPaymentDate',
                    label: 'Fecha vencimiento original',
                    type: 'date',
                  },
                  {
                    key: 'paymentDate',
                    label: 'Fecha vencimiento',
                    type: 'date',
                  },
                  {
                    key: 'amount',
                    label: 'Valor documento',
                    type: 'money',
                  },
                  {
                    key: 'documentRemainingAmount',
                    label: 'Adeudado Doc.',
                    type: 'money',
                  },

                  { key: 'fundName', label: 'Fondo' },
                ]}
                data={managements}
                actions={actions}
                showActions={true}
                rowsPerPageDefault={10}
                selected={selectedManagements}
                setSelected={setSelectedManagements}
                canSelectAll={true}
                exportToFile={'xlsx'}
                exportHeaders={[
                  {
                    key: 'businessIdentifier',
                    label: 'Rut cliente',
                  },
                  {
                    key: 'businessName',
                    label: 'Cliente',
                  },
                  { key: 'stakeholderIdentifier', label: 'Rut deudor' },
                  { key: 'stakeholderName', label: 'Deudor' },
                  { key: 'folio', label: 'Folio' },
                  { key: 'issuedDate', label: 'Fecha emisión', type: 'date' },
                  {
                    key: 'paymentDate',
                    label: 'Fecha vencimiento',
                    type: 'date',
                  },
                  { key: 'amount', label: 'Monto', type: 'money' },
                  { key: 'fundName', label: 'Fondo' },
                ]}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Salir
          </CustomButton>
        </DialogActions>
      </Dialog>
      <ConfirmAndExecuteDialog
        open={!!confirmDialogOpen}
        title={confirmDialogTitle}
        description={confirmDialogDescription}
        onConfirm={confirmAction}
        onCancel={() => setConfirmDialogOpen(false)}
        setOpen={setConfirmDialogOpen}
        buttonColor={buttonColor}
      />
      {openEditManagement && (
        <EditManagement
          openEditManagementId={openEditManagementId}
          open={openEditManagement}
          setOpen={setOpenEditManagement}
          setDescription={setDescription}
          description={description}
          possiblePaymentDate={possiblePaymentDate}
          setPossiblePaymentDate={setPossiblePaymentDate}
          setConfirmDialogTitle={setConfirmDialogTitle}
          setConfirmDialogDescription={setConfirmDialogDescription}
          setConfirmAction={setConfirmAction}
          setButtonColor={setButtonColor}
          setConfirmDialogOpen={setConfirmDialogOpen}
        />
      )}
      {rescheduleManagementOpen && (
        <RescheduleManagement
          open={rescheduleManagementOpen}
          setOpen={setRescheduleManagementOpen}
          openEditManagementId={openEditManagementId}
          dueDate={dueDate}
          setDueDate={setDueDate}
          setConfirmDialogTitle={setConfirmDialogTitle}
          setConfirmDialogDescription={setConfirmDialogDescription}
          setConfirmAction={setConfirmAction}
          setButtonColor={setButtonColor}
          setConfirmDialogOpen={setConfirmDialogOpen}
        />
      )}
      {openMultiComplete && (
        <MultiComplete
          open={openMultiComplete}
          setOpen={setOpenMultiComplete}
          managementsToComplete={managementsToComplete}
          byStakeholder={byStakeholder}
          handleOpenCreateNewManagementFromCompletion={
            handleOpenCreateNewManagementFromCompletion
          }
          handleOpenCreateNewMultiManagementFromCompletion={
            handleOpenCreateNewMultiManagementFromCompletion
          }
          reloadPage={reloadPage}
        />
      )}
      {openMultiDelete && (
        <MultiDelete
          open={openMultiDelete}
          setOpen={setOpenMultiDelete}
          managementsToDelete={managementsToDelete}
        />
      )}
      {openMultiReschedule && (
        <MultiReschedule
          open={openMultiReschedule}
          setOpen={setOpenMultiReschedule}
          managementsToReschedule={managementsToReschedule}
          byStakeholder={byStakeholder}
        />
      )}
      {openFilteredDocuments && (
        <DocumentIndicatorDocumentDetails
          open={openFilteredDocuments}
          setOpen={setOpenFilteredDocuments}
          documentsIds={documents.map((document: any) => document.id)}
        />
      )}

      <DocumentsPreviewer
        open={previewOpen}
        onClose={handleClosePreview}
        fileName={currentPreviewFile ?? ''}
        blobUrl={blobUrl}
        contentType={contentType}
        loading={previewLoading}
        error={previewError}
        onDownload={() => {
          if (currentPreviewFile) {
            const management = managements.find(
              (m: any) =>
                `${m.businessIdentifier}-${m.folio}.pdf` === currentPreviewFile,
            );
            if (management) {
              handleDownloadDocumentPDF(management.id);
            }
          }
        }}
        onError={(error) => setPreviewError(error)}
      />
      {openRequirementsDialog && (
        <RequirementsDialog
          open={openRequirementsDialog}
          onClose={() => setOpenRequirementsDialog(false)}
          category={'factoringDocument'}
          entityKey={'documentId'}
          entityId={documentId}
          entityAlias={documentAlias}
        />
      )}
    </div>
  );
};

export default ManagementsDetails;
